import React from "react"
import { graphql } from 'gatsby'
import Layout from "../components/Layout"
import { defineCustomElements as deckDeckGoHighlightElement } from '@deckdeckgo/highlight-code/dist/loader'
import "../styles/blog-details.scss"

export default function Blog({ data }) { 
  deckDeckGoHighlightElement();
  const { html } = data.markdownRemark
  const { title, tags } = data.markdownRemark.frontmatter

  return (
    <Layout>
      <main>
        <h1>{ title }</h1>
        <h3>{ tags }</h3>
        <div className="blog-content" dangerouslySetInnerHTML={{ __html: html }}/>
      </main>
    </Layout>
  )
}

export const query = graphql`
  query BlogDetails ($slug: String) {
    markdownRemark(frontmatter: {slug: {eq: $slug}}) {
      html
      frontmatter {
        stack
        tags
        title
      }
    }
  }
`

